export default __webpack_public_path__ + "media/images/Calendar_2-7c19276097e652060df05355d6fe91cc.png";